<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("guiaUsuario") }}
            </li>
          </ol>
        </nav>
      </div>
      <!-- Aquí comienza la sección del visor de PDF, Si queremos que tenga más height le ponemos asignar más de lo que tiene-->
      <div class="col-md-12">
        <iframe :src="computedPdfUrl" width="100%" height="750px"></iframe>
      </div>
      <!-- Fin de la sección del visor de PDF -->
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.checkLang();
  },

  methods: {
    checkLang() {
      let vm = this;

      const langCookie = document.cookie
        .split("; ")
        .find((row) => row.startsWith("language="));

      // Verificar si la cookie existe antes de intentar acceder a su valor
      if (langCookie) {
        vm.lang = langCookie.split("=")[1];
      } else {
        vm.lang = "es";
      }
    },
  },

  data() {
    return {
      lang: "es",
    };
  },

  computed: {
    computedPdfUrl() {
      //* * * * * * * * * * * * Aquí se le tendrá que pasar el lang para que pille el idioma.
      // return this.lang === "es"
      //   ? "https://selfibar.com/assets/docs/manual_selfibar_by_numier.pdf"},
      return "https://selfibar.com/assets/docs/manual_selfibar_by_numier.pdf";
    },
  },
};
</script>

<style scoped>
/* Puedes agregar estilos específicos para el visor de PDF aquí si es necesario */
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/GuiaUsuario/GuiaUsuario.vue